// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Saa-z","narrowOptionButtons":"Taa-z","noOptions":"Uaa-z"};